import { createSelector, createSlice, freeze, PayloadAction } from '@reduxjs/toolkit';
// Import Types
import type { CurrencyRates } from 'types';
// Import Store
import { selectUserSettingsCurrencyId } from './userData';

export interface CurrencyRatesSliceState {
    data: Nullable<CurrencyRates>;
}

export const initialState: CurrencyRatesSliceState = {
    data: null,
};

export const currencyRatesSlice = createSlice({
    name: 'currencyRates',
    initialState,
    reducers: (create) => ({
        setCurrencyRates: create.reducer((state, { payload }: PayloadAction<CurrencyRates>) => {
            // The rates matrix is large (every currency pair). A frozen value is not walked by Immer,
            // which otherwise traverses and deep-freezes every rate object and blocks the main thread.
            state.data = freeze(payload);
        }),
    }),
    selectors: {
        selectCurrencyRates: (currencyRates) => currencyRates.data,
    },
});

export const { setCurrencyRates } = currencyRatesSlice.actions;
export const { selectCurrencyRates } = currencyRatesSlice.selectors;

export const selectUserCurrencyRate = createSelector(
    [selectCurrencyRates, selectUserSettingsCurrencyId],
    (rates, currencyId) => rates?.[currencyId ?? '']?.EUR?.Rate,
);
